import React, { useEffect } from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import Testimonials from "../Home/Testimonials";
import GetInTouch from "../Home/GetInTouch";
import ServicesBoxIcon from "./ServicesBoxIcon";
import WhyChooseUs from "../Home/WhyChooseUs";

const OurServices = () => {
  useEffect(() => {
    document.title = "Our Services - NEX PE";
  }, []);

  return (
    <React.Fragment>
      <div class="page_wrapper">
        <Header headerType="white_header" />

        {/* breadcrumb area start */}
        <section className="nh_breadcrumb-area">
          <div
            className="nh_breadcrumb-wrap"
            data-background="assets/images/bg/breadcrumb.webp"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7">
                  <div className="nh_breadcrumb-content text-center">
                    <h2 className="nh_breadcrumb-content-title">
                      Our Services
                    </h2>
                    <div className="nh_breadcrumb-content-list">
                      <a href="/">Home</a>
                      <span>Our Services</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServicesBoxIcon />
        {/* 
        <WhyChooseUs /> */}

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default OurServices;
